// extracted by mini-css-extract-plugin
export var divider = "_le-0";
export var systemMessage = "_le-1";